<script lang="ts">
import { TypographyTags } from '@/utils/accessibility';
import { BuilderComponent } from '@/utils/cms';

export const Header1Registration: BuilderComponent = {
  name: 'Header1',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Header 1 text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    headerTag?: TypographyTags;
  }>(),
  {
    headerTag: 'h1',
  },
);
</script>

<template>
  <component :is="headerTag" class="font-bold header-1 font-gelica">
    <slot />
  </component>
</template>

<style scoped>
.header-1 {
  @apply mb-0;
  font-size: 32px;
  line-height: 36px;
}
@media (min-width: 1024px) {
  .header-1 {
    font-size: 48px;
    line-height: 52px;
  }
}
</style>
